import styled from 'styled-components';
import { Media } from '../../theme/Media';
const Section = styled.div `
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.grey00_1};
  flex: auto;
  padding: 15px 25px;
  position: ${({ $rel }) => $rel && 'relative'};
  @media ${Media.smMin} {
    padding: 40px 45px ${({ isForm }) => (isForm ? '25px' : '40px')} 45px;
  }
  ${({ theme }) => theme.shadows.small};
  & + & {
    margin-top: 5px;
  }
`;
export { Section };
